import { stickyItem } from '../components/sticky-item';

export default function menus() {
  $('.menus__menu').each(function () {
    stickyItem($(this).find('.menus__menu__hover img'), $(this));
  });
}
